import { FETCH_BLOCK_CATS } from '../actionTypes';

const initialState = null;

export default function(state = initialState, action=null){
  if (action.type === FETCH_BLOCK_CATS) {
    return {...action.payload};
  } else {
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/blockCats.js